export const bg = {
  'with-bg-covered': {
    bgColor: 'white',
    bgSize: 'cover',
    bgRepeat: 'no-repeat',
    bgPosition: 'center',
  }
};
